import * as React from "react";

import {
    Modal,
    Form,
    FormGroup,
    Label,
    Input,
    ModalFooter,
    Button,
    ModalBody,
    ModalHeader,
} from "reactstrap";

import i18n from "../i18n";

export interface MessagesEditProps {
    item: any;
    isOpen: boolean;
    isNew: boolean;
    onSave: (model: any) => void;
    onCancel: () => void;
}
export interface MessagesEditState {
    item: any;
}

export default class MessagesEdit extends React.Component<
    MessagesEditProps,
    MessagesEditState
    > {
    constructor(props: MessagesEditProps) {
        super(props);
        this.state = {
            item: props.item
        };
    }

    componentWillReceiveProps(nextProps: MessagesEditProps) {
        this.setState({
            item: nextProps.item
        });
    }

    render() {
        const { isOpen, onSave, onCancel, isNew } = this.props;
        const model = this.model;
        return (
            <Modal isOpen={isOpen}>
                <ModalHeader>
                    {isNew ? i18n.Messages.Form.NewTitle : i18n.Messages.Form.EditTitle}
                </ModalHeader>
                <ModalBody>
                    {model && (
                        <Form>
                            <FormGroup>
                                <Label>{i18n.Messages.Table.Keyword}</Label>
                                <br />
                                {!isNew && model.rowKey}
                                {isNew && (
                                    <Input
                                        size={50}
                                        value={model.rowKey}
                                        onChange={e => this.updateField("rowKey", e)}
                                    />
                                )}
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Messages.Table.Message}
                                    <Input
                                        size={50}
                                        value={model.message}
                                        onChange={e => this.updateField("message", e)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Messages.Table.Language}
                                    <Input
                                        size={50}
                                        value={model.lang}
                                        onChange={e => this.updateField("lang", e)}
                                    />
                                </Label>
                            </FormGroup>
                        </Form>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => onSave(model)} disabled={!this.isValid}>
                        {i18n.Global.Edit.Confirm}
                    </Button>
                    <Button color="default" onClick={() => onCancel()}>
                        {i18n.Global.Edit.Cancel}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    private get model() {
        return this.state.item;
    }

    private get isValid(): boolean {
        return this.model && !!this.model.rowKey;
    }

    private updateField(
        field: string,
        e: React.ChangeEvent<HTMLInputElement> | null,
        value?: any
    ) {
        const temp = {};
        temp[field] = e ? e.target.value : value;
        this.setState({
            item: {
                ...this.state.item,
                ...temp
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/messages/messages-edit.tsx